import React from "react";

import GroupAccess from "./GroupAccess";

type JoinSettingsArgs = {
  isActiveMainGroup: boolean;
  canCreateHidden: boolean;
  sensitive: boolean;
};

export default function JoinSettings(props: JoinSettingsArgs) {
  return (
    <>
      <h3>{I18n.t("js.groups.edit.join_settings")}</h3>
      <GroupAccess {...props} />
    </>
  );
}
